import { toast } from "react-toastify";
import {
  getCompanyUserInvitations,
  sendEmailInvitation,
  sendEmailInvitationSuccess,
} from "../../../store/companyToUser/action";
import React, { useEffect, useState } from "react";
import { isEmpty } from "lodash";
import { useDispatch, useSelector } from "react-redux";
import PersonAddOutlinedIcon from "@mui/icons-material/PersonAddOutlined";

import AppModal from "../../Common/AppModal";

const SendUserInvitation = ({ modal, setModal, toggle }) => {
  const dispatch = useDispatch();
  const [userInvitationEmail, setUserInvitationEmail] = useState("");
  const {
    companyUserInvitationsAPI,
    sendUserInviteSuccessAPI,
    sendUserInviteSuccessLoading,
  } = useSelector((state) => ({
    companyUserInvitationsAPI:
      state.CompanyToUser.companyUserInvitations?.userinvitation_list,
    sendUserInviteSuccessAPI: state.CompanyToUser.sendUserInviteSuccess,
    sendUserInviteSuccessLoading:
      state.CompanyToUser.sendUserInviteSuccessLoading,
  }));
  const handleSendUserInvitationEmail = (Email) => {
    // check if email is valid email syntax regex
    if (
      !Email ||
      !Email?.match(
        // eslint-disable-next-line no-control-regex
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@(([^<>()[\]\\.,;:\s@"]+\.)+[^<>()[\]\\.,;:\s@"]{2,})$/i
      )
    ) {
      toast.error("Please enter a valid email address");
      return;
    }

    dispatch(sendEmailInvitation([{ Email }]));
  };
  useEffect(() => {
    if (isEmpty(sendUserInviteSuccessAPI)) return;
    if (sendUserInviteSuccessAPI?.status === 200) {
      toast.success(sendUserInviteSuccessAPI?.message);
      dispatch(getCompanyUserInvitations());
      toggle();
    } else {
      toast.error(sendUserInviteSuccessAPI?.message);
    }

    dispatch(sendEmailInvitationSuccess([]));
  }, [sendUserInviteSuccessAPI]);
  return (
    <>
      <AppModal
        open={modal}
        onClose={toggle}
        title="Send User Invitation"
        icon={<PersonAddOutlinedIcon />}
        headerAccent="indigo"
        size="sm"
        loading={sendUserInviteSuccessLoading}
        loadingText="Please wait…"
        submitLabel="Send Invitation"
        submitColor="primary"
        onSubmit={() => handleSendUserInvitationEmail(userInvitationEmail)}
      >
          <div className={"d-flex  mb-2 w-100"}>
            <div className={"d-flex flex-row align-items-center mb w-100"}>
              <input
                className={"form-control send-user-invitation-email-input me-1"}
                style={{ width: "100%" }}
                type="text"
                placeholder="Enter email"
                value={userInvitationEmail}
                onChange={(e) => setUserInvitationEmail(e.target.value)}
              />
            </div>
          </div>
      </AppModal>
    </>
  );
};

export default SendUserInvitation;
